module.exports = __webpack_public_path__ + "static/media/logo_footer.2ad671b4.png";